import Home from './components/home/home';
import Share from './components/share/share';
import Banner from './components/banner/banner';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import Gallery from './components/gallery/gallery';
import Introduction from './components/introduction/introduction';
import './App.css';

const App = () => {
    return (
        <div className="App">
			<Header />
			<Introduction />
			<Home />
            <Gallery />
            <Share />
            <Banner />
            <Footer />
        </div>
    )
}

export default App;
